(ns frontend.view.nev.surveys.form.status-submitted
    (:require
     [common.localization :as loc]
     [frontend.view.nev.surveys.form.components :as components]
     [frontend.view.nev.surveys.form.sub :as sub]
     [frontend.view.nev.surveys.form.event :as event]
     [re-frame.core :as rf]
     [ui.components.button.view :as button]
     [ui.view.survey.sub :as survey-view-sub]
     [ui.view.survey.view :as survey]))

(defn view
  []
  (let [config @(rf/subscribe [::sub/new-config])
        previous-answers @(rf/subscribe [::sub/previous-answers])
        config-with-previous (assoc config :previous-answers previous-answers)]
    [:div.flex.flex-auto.flex-col.overflow-hidden
     [:div
      {:class-name "p-4 flex-1 overflow-auto"}
      [survey/view config-with-previous false true]]]))

(defn footer
  []
  (let [survey-id @(rf/subscribe [::sub/survey-id])
        unsaved-answers @(rf/subscribe [::survey-view-sub/unsaved-survey-answers survey-id])
        missing-answers @(rf/subscribe [::survey-view-sub/missing-survey-answers survey-id])
        show-missing? @(rf/subscribe [::survey-view-sub/show-missing? survey-id])
        lang @(rf/subscribe [::survey-view-sub/selected-lang survey-id])
        saving? @(rf/subscribe [::survey-view-sub/saving-survey? survey-id])
        submitting? @(rf/subscribe [::survey-view-sub/submitting? survey-id])]
    [:div
     {:class "shadow-sm"}
     [:div
      {:class "p-3 mx-auto max-w-[1024px] flex justify-between gap-2"}
      [:div
       {:class-name "flex gap-3"}
       (if (empty? unsaved-answers)
         [components/editor-exit-button]
         [components/editor-exit-without-saving-button])]
      [:div
       {:class-name "flex gap-3"}
       [components/editor-delete-button false]
       [button/secondary-hollow
        {:on-click  #(rf/dispatch [::event/save survey-id])
         :disabled? (or saving? submitting? (empty? unsaved-answers))}
        (if saving?
          [:<>
           [:svg.animate-spin.-ml-1.mr-3.h-5.w-5.text-white {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24"}
            [:circle.opacity-25 {:cx "12" :cy "12" :r "10" :stroke "currentColor" :stroke-width "4"}]
            [:path.opacity-75 {:fill "currentColor" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]]
           (loc/tr :saving nil lang)]
          (loc/tr :save nil lang))]
       [button/primary-solid
        {:on-click  (fn [_]
                      (if (empty? unsaved-answers)
                        (rf/dispatch [::event/submit survey-id])
                        (rf/dispatch [::event/save survey-id true])))
         :disabled? (or submitting?
                        saving?
                        (and missing-answers show-missing?))}
        (cond submitting?
              [:<>
               [:svg.animate-spin.-ml-1.mr-3.h-5.w-5.text-white {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24"}
                [:circle.opacity-25 {:cx "12" :cy "12" :r "10" :stroke "currentColor" :stroke-width "4"}]
                [:path.opacity-75 {:fill "currentColor" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]]
               (loc/tr :submitting nil lang)]
              (empty? unsaved-answers)
              (loc/tr :approve nil lang)
              :else
              (loc/tr :save-and-approve nil lang))]]]]))

